import { auth } from "@canva/user";
import { CONFIG } from "@/config";
const BACKEND = CONFIG.BACKEND_BASE;
const origFetch = window.fetch.bind(window);
function toBackend(url) {
  if (/^https?:\/\//i.test(url)) return url;
  if (/^\/?api\//i.test(url)) { const p = url.startsWith("/") ? url : `/${url}`; return BACKEND + p; }
  return url;
}
window.fetch = async (input, init = {}) => {
  let url = typeof input === "string" ? input : input?.url;
  let rewritten = url;
  if (typeof url === "string") {
    const r = toBackend(url);
    if (r !== url) { input = r; rewritten = r; }
  }
  let addedAuth = false;
  try {
    const target = new URL(typeof input === "string" ? input : input?.url);
    if (target.origin === new URL(BACKEND).origin) {
      const token = await auth.getCanvaUserToken();
      const headers = new Headers(init.headers || {});
      headers.set("Authorization", `Bearer ${token}`);
      init = { ...init, headers };
      addedAuth = true;
    }
  } catch {}
  console.debug("[fetch-shim]", { from: url, to: rewritten, addedAuth });
  return origFetch(input, init);
};
console.info("[api] base:", BACKEND);
